import React from 'react';
import s from './s.module.less';
import Icon from './icon.png';
import { Button, Divider, Input, InputNumber, message, Select, Spin } from 'antd';
import { disconnetFromGoogle } from 'api/provider';
import useGoogleAuthStatus from 'hooks/useGoogleAuthStatus';
import { ReminderSettings } from 'types/calendarSetting';
import { updateReminderSettings } from 'api/calendarSetting';

interface MinimumTimeProps {
    onUpdate: () => void;
    value?: ReminderSettings,
}

const MinimumTime = (props: MinimumTimeProps) => {
    const { onUpdate, value } = props;
    const [timeSet, setTimeSet] = React.useState(0);
    const [inputHour, setInputHour] = React.useState<number>();
    const [loading, setLoading] = React.useState(false);

    const showEdit = timeSet === -1;

    React.useEffect(() => {
        setTimeSet(value?.minAdvanceBookingHours || 0);
    }, [value]);

    const options = [
        {
            label: 'No restriction',
            value: 0,
        },
        {
            label: '1 hour',
            value: 1,
        },
        {
            label: '2 hour',
            value: 2,
        },
        {
            label: '3 hour',
            value: 3,
        },
        {
            label: '4 hour',
            value: 4,
        },
    ];

    const exist = options.find((item) => {
        return item.value === timeSet;
    })
    if (!exist) {
        options.push({
            label: timeSet + ' hour',
            value: timeSet,
        })
    }

    options.push(
        {
            label: 'Custom',
            value: -1,
        }
    )

    const handleChange = async (hour: number) => {
        if (hour === -1) {
            setTimeSet(-1);
            return;
        }
        const data = {
            minAdvanceBookingHours: hour,
        }
        setLoading(true);
        const result = await updateReminderSettings(data);
        setLoading(false);
        if (!result.error) {
            message.success("Advance time updated successfully!")
            onUpdate();
        }
    }

    const onOk = async () => {
        const data = {
            minAdvanceBookingHours: inputHour,
        }
        setLoading(true);
        const result = await updateReminderSettings(data);
        setLoading(false);
        if (!result.error) {
            message.success("Advance time updated successfully!")
            onUpdate();
            setInputHour(undefined);
        }
    }

    const onCancel = () => {
        setTimeSet(value?.minAdvanceBookingHours || 0);
    }

    return (
        <div className={s.wrap}>
            <div className="text-gray-800 text-xl font-medium">Minimum time in advance</div>
            <Divider />
            <div className={s.tips}>Set how many hours in advance patients need to book, so you have time to prepare between appointments</div>
            {
                !showEdit &&
                <div>
                    <Spin spinning={loading}>
                        <div className={s.item}>
                            <Select
                                loading={loading}
                                value={timeSet}
                                onChange={handleChange}
                                style={{ width: '250px', marginTop: '16px' }}>
                                {
                                    options.map((item) => {
                                        return (
                                            <Select.Option value={item.value}>
                                                {item.label}
                                            </Select.Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>
                    </Spin>
                    {
                        timeSet ? <div className={s.subTips}>Patients must book at least {timeSet} hours in advance</div> : null
                    }
                </div>
            }
            {
                showEdit && (
                    <div className={s.itemEdit}>
                        <div className={s.inputWrap}>
                            <InputNumber
                                className={s.input}
                                value={inputHour}
                                maxLength={3}
                                onChange={(val) => {
                                    if (!val) {
                                        setInputHour(val || undefined);
                                        return;
                                    }
                                    if (val < 0) {
                                        setInputHour(1)
                                    } else if (val > 240) {
                                        setInputHour(240)
                                    } else {
                                        setInputHour(val);
                                    }
                                }}
                                controls={false}
                                step={0} min={1} max={240} />
                            {/* <Input
                                className={s.input}
                                value={inputHour}
                                maxLength={3}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (!value && value !== '0') {
                                        setInputHour(undefined);
                                        return;
                                    }
                                    if (/^\d*$/.test(value)) {
                                        // 仅当输入为数字时才更新状态，否则可忽略更新逻辑
                                        setInputHour(parseInt(value));
                                    }
                                }}
                            /> */}
                            hours
                        </div>
                        <div className={s.inputAction}>
                            <Button
                                onClick={onCancel}
                                className={s.btn}>
                                Cancel
                            </Button>
                            <Button
                                loading={loading}
                                onClick={onOk}
                                type='primary'
                                className={s.btn}>
                                Save
                            </Button>
                        </div>
                    </div>
                )
            }
        </div>
    );
};

export default MinimumTime;
